import type { FunctionComponentWithRef } from "react";
import { graphql, useFragment } from "react-relay";

import { BaseLinkContextProvider } from "shared/components/common/base-link/context";
import { tracking } from "shared/data";
import { getAbsoluteUrl } from "shared/lib/utils";

import { sendGA4Tracking } from "scmp-app/components/tracking/google-analytics-4/apis";
import type { heroArticlesHomeV2Content$key } from "scmp-app/queries/__generated__/heroArticlesHomeV2Content.graphql";

import { StyledHeroArticle } from "./styles";

type Props = {
  className?: string;
  reference: heroArticlesHomeV2Content$key;
};

export const HomeV2HeroArticles: FunctionComponentWithRef<Props, HTMLDivElement> = ({
  className,
  ref,
  reference,
}) => {
  const content = useFragment(
    graphql`
      fragment heroArticlesHomeV2Content on Content {
        ...topStoriesItemV2Content
      }
    `,
    reference,
  );

  if (!content) return null;

  return (
    <BaseLinkContextProvider
      customQueryParameters={{
        module: tracking.module.TopStory,
      }}
    >
      <StyledHeroArticle
        className={className}
        isShowImage
        onClick={(clickedEntityId, urlAlias) => {
          sendGA4Tracking({
            action: "click",
            category: "recirculation",
            customized_parameters: {
              article_id: clickedEntityId,
              article_seq: "1",
              destination_url: getAbsoluteUrl(urlAlias),
              page_type: "homepage",
              widget_name: "top_story1",
            },
            subcategory: "widget",
          });
        }}
        ref={ref}
        reference={content}
        withCarousel
        withExclusiveHeaderFlag
        withSection={false}
        withSeriesShortLabel
        withSummary
      />
    </BaseLinkContextProvider>
  );
};

HomeV2HeroArticles.displayName = "HomeV2HeroArticles";
